const validation = require('bluegg-validation');
const WebFont = require('webfontloader');
import AOS from 'aos';

WebFont.load({
    google: {
        families: ['Muli:400,900&display=swap']
    },
});


/** Animation **/
AOS.init({
    offset: 0,
    duration: 500,
    once: true,
});

/** Modules **/

/*** Lazy Load ***/
import loadFunction from "./modules/lazy-load"

if (document.readyState !== 'loading') {
    loadFunction(); 
} else {
    document.addEventListener("DOMContentLoaded", loadFunction, true);
}
window.addEventListener('scroll', loadFunction, true);
document.addEventListener('posts-loaded', loadFunction, true);

/*** Accessibility ***/
import accessibilityJS from "./modules/accessibility"
accessibilityJS();

/** Atoms **/

/*** Videos ***/
import videos from "./atoms/video"
videos();

/*** Modal ***/
import modal from "./atoms/modal"
modal();

/*** Show/Hide ***/
import showHide from "./atoms/show-hide"
showHide();

/**
* title Dropdowns
* description Create manual dropdowns if a select isn't viable 
*/

function customDropdown() {
    const dropdownParent = document.querySelector('[data-dropdown-parent]');
    if (document.body.contains(dropdownParent)) {
        const dropdownParent = document.querySelectorAll('[data-dropdown-parent]');
        for (let i = 0; i < dropdownParent.length; i++) {
            const dropdownChild = dropdownParent[i].querySelectorAll('[data-dropdown-button]');
            const dropdown = dropdownParent[i].querySelector('[data-dropdown]');
            for (let i = 0; i < dropdownChild.length; i++) {
                dropdownChild[i].addEventListener('click', function(e) {
                    dropdown.classList.toggle('active');
                    dropdown.parentNode.toggleAttribute('data-dropdown-open');
                });
            }
        }
    }
};

customDropdown();


/** Molecules **/
    
/*** Menu ***/
    
import "./molecules/menu"

/*** Accordions ***/
import accordionControls from "./molecules/accordion"

/*** Tab Navigation ***/
import tabNavigation from "./molecules/tabs"
tabNavigation();


/** Organisms **/







